import axios from "axios";

import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// DCA BUDGET AMENDMENT RELATED APIs
// ==============================================

// 1. Get Budget Assigned CC
export const getBudgetAssignedCC = async () => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetBudgetAssignedCC`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 2. Get DCA Budget Details
export const getDCABudgetDetails = async (ccCode, subtype, year, ccTypeId) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetDCABudgetDetails?CCCode=${ccCode}&Subtype=${subtype}&Year=${year}&CCTypeId=${ccTypeId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 3. Get Budget Assigned CC By ID
export const getBudgetAssignedCCById = async (ccCode, year) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetBudgetAssignedCCByID?CCCode=${ccCode}&Year=${year}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 4. Save Single DCA Amend Budget
export const saveSingleDCAAmendBudget = async (budgetData) => {
    try {
        
        const response = await axios.post(
            `${API_BASE_URL}/Accounts/SaveSingleDCAAmendBudget`,
            budgetData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        
        return response.data;
        
    } catch (error) {
        
        if (error.response) {
        } else if (error.request) {
        } else {
        }
        
        
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response?.status === 400) {
            throw new Error('Bad Request: Invalid budget data or missing required fields');
        } else if (error.response?.status === 500) {
            throw new Error('Server Error: Please contact administrator');
        }
        
        throw error;
    }
};

// 5. Multiple DCA Amend
export const multipleDCAAmend = async (amendData) => {
    try {
        
        const response = await axios.post(
            `${API_BASE_URL}/Accounts/MultipleDCAAmend`,
            amendData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        
        return response.data;
        
    } catch (error) {
        
        if (error.response) {
        } else if (error.request) {
        } else {
        }
        
        
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response?.status === 400) {
            throw new Error('Bad Request: Invalid amendment data or missing required fields');
        } else if (error.response?.status === 500) {
            throw new Error('Server Error: Please contact administrator');
        }
        
        throw error;
    }
};

// 6. Get Verification DCA Amends
export const getVerificationDCAAmends = async (roleId, userId) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetVerificationDCAAmends?Roleid=${roleId}&Userid=${userId}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 7. Get Verify DCA Budget Amend by ID (NEW API)
export const getVerifyDCABudgetAmendById = async (ccCode, fyear, ctype, status) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetVerifyDCABudgetAmendbyId?CCCode=${ccCode}&Fyear=${fyear}&Ctype=${ctype}&Status=${status}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 8. Get DCA Budget Amend Grid
export const getDCABudgetAmendGrid = async (ccCode, fyear, status) => {
    try {
         // DEBUG
        
        const response = await axios.get(
            `${API_BASE_URL}/Accounts/GetDCABudgetAmendgrid?CCCode=${ccCode}&Fyear=${fyear}&Status=${status}`,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        
         // DEBUG
        return response.data;
    } catch (error) {
        if (error.response?.data) {
            throw error.response.data;
        }
        throw error;
    }
};

// 9. Update Approval DCA Budget Amend (Return Handler)
export const updateApprovalDCABudgetAmend = async (updateData) => {
    try {
        
        // Log a sample of the data being sent
        
        const response = await axios.put(
            `${API_BASE_URL}/Accounts/UpdateApprovalDCABudgetAmend`,
            updateData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000
            }
        );
        
        
        return response.data;
        
    } catch (error) {
        
        if (error.response) {
            
            if (error.response.status === 400) {
            }
            
        } else if (error.request) {
        } else {
        }
        
        
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response?.status === 400) {
            throw new Error('Bad Request: Invalid update data or missing required fields');
        } else if (error.response?.status === 500) {
            throw new Error('Server Error: Please contact administrator');
        }
        
        throw error;
    }
};

// 10. Approve DCA Budget Amend
export const approveDCABudgetAmend = async (approvalData) => {
    try {
        
        // Log a sample of the data being sent
        
        const response = await axios.put(
            `${API_BASE_URL}/Accounts/ApproveDCABudgetAmend`,
            approvalData,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                timeout: 30000 // 30 second timeout for complex operations
            }
        );
        
        
        return response.data;
        
    } catch (error) {
        
        if (error.response) {
            // Server responded with error status
            
            // Log specific error details for 400 errors
            if (error.response.status === 400) {
            }
            
        } else if (error.request) {
            // Request was made but no response received
        } else {
            // Something else happened
        }
        
        
        // Return more specific error information
        if (error.response?.data) {
            throw error.response.data;
        } else if (error.response?.status === 400) {
            throw new Error('Bad Request: Invalid data format or missing required fields');
        } else if (error.response?.status === 500) {
            throw new Error('Server Error: Please contact administrator');
        }
        
        throw error;
    }
};